import 'semantic-ui-calendar/dist/calendar.min'; // https://github.com/mdehoog/Semantic-UI-Calendar

const settings = {
  today: true,
  text: {
    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  },
};

const datePicker = ($container) => {
  $container || ($container = $('body'));

  const $calendar = $container.find('@calendar');
  const $rangeCalendar = $container.find('@rangeCalendar');
  let i = 0;

  for (i; i < $rangeCalendar.length; i += 1) {
    const $item = $($rangeCalendar[i]);
    const $type = $item.data('kind');

    const $starts = $item.find($('@starts'));
    const $ends = $item.find($('@ends'));

    settings.type = $type;
    settings.startCalendar = $starts;
    settings.endCalendar = $ends;

    $starts.calendar(settings);
    $ends.calendar(settings);
  }

  for (i; i < $calendar.length; i += 1) {
    const $item = $($calendar[i]);
    const $type = $item.data('kind');

    settings.type = $type;

    $item.calendar(settings);
  }
};

export default datePicker;
